import React, { useEffect, useState } from "react";
import { routes } from "../gen/General";

/**
 * basado en al extension del archivo determina si se puede mostrar preview del mismo (si son imagenes)
 * o mostrar un icono representativo del archivo
 * @param archivo file
 * @param hash hash
 * @param local is local (cuando aun no se sube al server)
 * @returns {[string, boolean]|*}
 */
const get_thumbnail_src = (archivo, hash, local = false) => {
    // show only icon if file or image
    if (!archivo) {
        return ["/img/file.png", false];
    }
    if (archivo.indexOf(".pdf") > 0) {
        return ["/img/pdf.png", true];
    } else if (archivo.indexOf(".doc") > 0) {
        return ["/img/doc.png", false];
    } else if (archivo.indexOf(".txt") > 0) {
        return ["/img/txt.png", false];
    } else if (archivo.indexOf(".xls") > 0) {
        return ["/img/xls.png", false];
    } else if (archivo.indexOf(".csv") > 0) {
        return ["/img/csv.png", false];
    }

    return local
        ? ["/img/file.png", false]
        : [routes.api + "/examenes/examn-files/thumbnail/" + hash + "/" + archivo, true];
};

export const ThumbnailLocal = ({ archivo, onClose }) => {
    let [thumbnailSrc, setThumbnailSrc] = useState(get_thumbnail_src(archivo.name, null, true)[0]);

    useEffect(() => {
        if (thumbnailSrc === "/img/file.png") {
            let reader = new FileReader();
            reader.onloadend = () => {
                setThumbnailSrc(reader.result);
            };
            if (archivo) {
                reader.readAsDataURL(archivo);
            }
        }

        return () => {
            // https://react-dropzone.js.org/#section-previews
            URL.revokeObjectURL(thumbnailSrc);
        };
    }, [archivo]);

    return (
        <div className="thumbnail">
            <div className="image">
                <img src={thumbnailSrc} alt={`img-${archivo.name}`} className="st-80" />
            </div>

            {/*<div className='info'>{archivo.name}</div>*/}
            {onClose && (
                <button type="button" className="close" onClick={onClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            )}
        </div>
    );
};
